class SizeMessaging extends HTMLElement {
  constructor() {
    super();
  }

  modifiers = {
    hidden: "hidden"
  };

  attributes = {
    productId: "product-id",
    dataSource: "data-source",
    instructionsId: "instructions-id",
    disclaimerId: "disclaimer-id"
  };

  dataSources = {
    default: "default",
    reviews: "reviews"
  };

  get productId() {
    return this.getAttribute(this.attributes.productId);
  }

  get dataSource() {
    return this.getAttribute(this.attributes.dataSource);
  }

  get okendoUserId() {
    return theme.okendo_user_id;
  }

  get instructionsId() {
    return this.getAttribute(this.attributes.instructionsId);
  }

  get disclaimerId() {
    return this.getAttribute(this.attributes.disclaimerId);
  }

  async connectedCallback() {
    const url = `https://api.okendo.io/v1/stores/${this.okendoUserId}/products/shopify-${this.productId}/review_aggregate`;

    const response = await fetch(url);
    const data = await response.json();

    const { reviewAggregate } = data;
    const { attributeRatings } = reviewAggregate || {};

    if (!attributeRatings || !attributeRatings.length) {
      this.showDefaultWidget();
      return;
    }

    const [attributeRating] = attributeRatings;
    const { value } = attributeRating;

    this.attributeRatingValue = value;

    this.showReviewsBasedWidget();
  }

  showDefaultWidget() {
    this.setAttribute(this.attributes.dataSource, this.dataSources.default);
    document.body.setAttribute("data-size-messaging-source", this.dataSources.default);

    this.classList.remove(this.modifiers.hidden);
  }

  showReviewsBasedWidget() {
    this.setAttribute(this.attributes.dataSource, this.dataSources.reviews);
    document.body.setAttribute("data-size-messaging-source", this.dataSources.reviews);

    const instructionsElement = document.getElementById(this.instructionsId);
    instructionsElement.innerHTML = this.getInstructions(this.attributeRatingValue);

    this.classList.remove(this.modifiers.hidden);
  }

  getInstructions(value) {
    const roundedValue = Math.round(value * 100) / 100;

    if (roundedValue >= 0 && roundedValue <= 0.09) {
      return theme.strings.sizing.true_to_size;
    } else if (roundedValue >= 0.10 && roundedValue <= 0.49) {
      return theme.strings.sizing.runs_slightly_large;
    } else if (roundedValue >= 0.5 && roundedValue <= 1) {
      return theme.strings.sizing.runs_large;
    } else if (roundedValue >= -0.09 && roundedValue <= 0) {
      return theme.strings.sizing.true_to_size;
    } else if (roundedValue >= -0.49 && roundedValue <= -0.10) {
      return theme.strings.sizing.runs_slightly_small;
    } else if (roundedValue >= -1 && roundedValue <= -0.5) {
      return theme.strings.sizing.runs_small;
    } else {
      return "";
    }
  }
}

if (!customElements.get("size-messaging")) {
  customElements.define("size-messaging", SizeMessaging);
}
